import React, { useCallback, useEffect, useContext } from 'react';
import { MenuContext, PathContext } from '../App';
import useLocalStorage from '../hooks/useLocalstorage';
import { Content } from '../components/Layout';
import { HeaderContainer, Buttons } from '../style';
import { PageHeader, Button } from 'scorer-ui-kit';
import styled from 'styled-components';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const Container = styled(Content) <{ marginLeft?: string }>`
  display: flex;
  flex: 1;
  margin-left: ${({ marginLeft }) => marginLeft ? marginLeft : '295px'};
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 60px 50px 25px 50px;
  transition: 0.2s;
`;

const TasksetView = () => {
  const { setSelectedStep } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const { floorPlanStorage } = useLocalStorage();

  /*---------route---------*/
  const onContinue = useCallback((index: number) => {
    setSelectedStep(index);
  }, [setSelectedStep]);

  useEffect(() => {
    if (pathUpdated) { setSelectedStep(2); }
  }, [pathUpdated, setSelectedStep]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='タスクセット一覧' areaHref='/' />
        <Buttons>
          <Button design='primary' size='small' onClick={() => onContinue(13)}>編集</Button>
        </Buttons>
      </HeaderContainer>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>タスクセット名</TableCell>
              <TableCell>関連付けタスク</TableCell>
              <TableCell>関連付けジョブ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {floorPlanStorage.tasksets.map((taskset: any) => {
              let rowSpanNum = taskset.taskList.length+1;
              for (let i=0; i< taskset.taskList.length; i++) {
                rowSpanNum += taskset.taskList[i].jobList.length;
              }
              return (
                <>
                  <TableRow>
                    <TableCell rowSpan={rowSpanNum}>{taskset.name}</TableCell>
                  </TableRow>
                  {taskset.taskList.map((task: any) => {
                    return (
                      <>
                        <TableRow>
                          <TableCell rowSpan={task.jobList.length+1}>{task.name}</TableCell>
                        </TableRow>
                        {task.jobList.map((job: any) => {
                          return (
                            <TableRow key={job.id}>
                              <TableCell>{job.name}</TableCell>
                            </TableRow>
                          );
                        })}
                      </>
                    );
                  })}
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default TasksetView;
